import type { MstImport } from '../models';
import { MstImportRaw } from '../models';

function createMstImportFormData<S extends MstImport, R extends MstImportRaw>(
  extraParams: object | undefined,
  file: File | null,
  mstImport: S,
  recordClass?: { fromModel: (file: File, mstImport: S) => R },
) {
  const formData = new FormData();
  const data = {
    ...extraParams,
    ...(recordClass?.fromModel ?? MstImportRaw.baseFromModel)(file, mstImport),
  };
  if (data.file)
    formData.append(
      'file',
      new File([data.file], data.file.name, { type: `${data.file.type}; charset=${data.characterCode}` }),
    );
  formData.append(
    'values',
    new Blob([JSON.stringify({ importClass: data.importClass, jobComment: data.jobComment })], {
      type: 'application/json',
    }),
  );
  return formData;
}

export { createMstImportFormData };
